/* cSpell:disable */
/* eslint max-len: ["error", { "ignoreStrings": true, "ignoreTemplateLiterals": true, ignoreComments: true }] */
export const texts = {
  welcome: {
    male: "ברוך הבא לניהול פרויקט 10K",
    female: "ברוכה הבאה לניהול פרויקט 10K",
  },
  sendMicrobiomeReport: 'שלח דו"ח מיקרוביום',
  sendUltrasoundReport: 'שלח דו"ח אולטרסאונד',
  lab: "מעבדה",
  visit: "ביקור",
  outgoingCall: "שיחה יוצאת",
  visit00: "ביקור ראשוני",
  unplannedVisit: "ביקור ביניים",
  visitType: "שלב במחקר",
  addVisit: "הוספת ביקור חדש",
  visitSuccessfulyAdded: "הביקור נוסף בהצלחה",
  participantUpdatesSuccsesfully: "Participant Updated Succsessfully",
  visitUpdatesSuccsesfully: "Visit Updated Succsessfully",
  appInfoUpdatesSuccsesfully: "App Info Updated Succsessfully",
  wrongFileFormat: "פורמט הקובץ חייב להיות: ",
  goodSleepPrecentage: "אחוז שינות מתועדות",
  goodSleepNights: "לילות עם שינה",
  badSleepNights: "לילות בלי תיעוד שינה",
  totalSleepNights: "לילות שעברו מאז נלקח החיישן",
  sleepValidationReport: " מעקב אחר דיווח על שינה",
  foodValidationReport: "דוח מילוי ארוחות",
  goodFoodPrecentage: "אחוז ימים תקינים",
  goodFoodDays: "ימים עם תיעוד תקין",
  badFoodDays: "ימים עם תיעוד לא תקין",
  totalFoodDays: "ימים שעברו מאז נלקח החיישן",
  noHospitalizations: "אין אשפוזים",
  serachParticipant: "חיפוש משתתף",
  startDay: "יום התחלה",
  endDay: "יום סיום",
  comments: "הערות",
  uploadMedications: "העלאת תרופות",
  noMedicalProcedures: "אין הליכים רפואיים",
  haventContacted: "עוד לא נוצר איתו קשר",
  lastCallDate: "שיחה יוצאת אחרונה",
  scheduling: "זימון פגישות",
  noAnswer: "אין מענה",
  lastTookTest: ":Last took the test at",
  enterCall: "כנס לפגישה",
  scheduledMeeting: "קבע פגישה",
  finishedMeeting: "סיים פגישה",
  filledInitialSurvey: "מילא שאלון התחלתי",
  filledBloodTests: "העלה בדיקות דם",
  sendMail: "שלח מייל",
  firstYear: "מעקב שנה ראשונה",
  secondYear: "מעקב שנה שניה",
  thirdYear: "מעקב שנה שלישית",
  forthYear: "מעקב שנה רביעית",
  fifthYear: "מעקב שנה חמישית",
  sixthYear: "מעקב שנה שישית",
  seventhYear: "מעקב שנה שביעית",
  eighthYear: "מעקב שנה שמינית",
  ninthYear: "מעקב שנה תשיעית",
  callCenter: "מעקב טלפוני",
  meetingTime: "זמן פגישה",
  nextAppointments: "פגישות קרובות",
  unscheduledAppointments: "פגישות לפני קביעת תור",
  missedAppointments: "פגישות שהתפספסו",
  updateCgmStatus: "עדכון סטטוס חיישן",
  add: "הוספה",
  addFile: "הוסף קובץ",
  missingFoods: "מזונות חסרים",
  admin: "מנהל",
  alreadyRegistered: "כבר רשום?",
  participants: "משתתפים",
  confilct: "מבחנה/ערכה זו נשמרה עבור משתתף אחר.",
  conflictWithPid: "מבחנה/ערכה זו נשמרה עבור משתתף מספר:",
  open: "פתח",
  daysAgo: "מספר ימים מהסריקה",
  message: "הודעה",
  tooManyRequuests: "בקשות רבות מדי. אנא פנה לתמיכה.",
  keepOldDataWarning:
    "מילוי חוזר לאותו משתתף אינו מוחק את המידע שנשמר בפעם הוקדמת וכל הנתונים יישמרו.",
  close: "סגור",
  registeredAt: "נרשם בתאריך",
  uploadingForYourself: {
    bloodTests: "הנך מעלה בדיקות דם לעצמך",
  },
  weTryHarderMedicalFiles:
    "אנחנו עושים מאמצים רבים על מנת לפענח את הקבצים באופן אוטומטי אך לצערינו לא תמיד אנחנו מצליחים.",
  sendUsBloodTests: {
    male: "אם נתקלת בשגיאות אל תהסס לשלוח לתמיכה את בדיקות הדם שלך ונזין אותן למערכת באופן ידני.",
    female:
      "אם נתקלת בשגיאות אל תהססי לשלוח לתמיכה את בדיקות הדם שלך ונזין אותן למערכת באופן ידני.",
  },
  send: "שלח",
  initialAfterExcluded:
    "מסומן לנו שנדחת מהמחקר ולכן אינך יכול למלא את השאלון שוב. אנא פנה לתמיכה",
  thanksForUploading: "תודה על העלאת הקובץ",
  treatedAndSend: "סמן כטופל והשב",
  answer: "תשובה",
  freeText: "טקסט חופשי",
  areYouSure: "האם אתה בטוח?",
  areYouSureYouWantToLeave: "האם אתה בטוח שאתה רוצה להתנתק?",
  gender: "מגדר",
  maleGender: "גבר",
  femaleGender: "אישה",
  old: "ישן",
  usersNotReturnedSleep: "משתתפים שלא החזירו חיישן שינה",
  new: "חדש",
  unknown: "לא ידוע",
  chooseAnswer: "בחר תשובה",
  treatWithoutSendAnswer: "סמן בלי תשובה",
  alreadyExistsLong:
    "הדיאטניות שלנו בדקו את בקשתך אך המזון לא התווסף מכיוון שהמזון כבר קיים במאגר.",
  alreadyExists: "קיים במאגר",
  recipieNotAllowedLong:
    "הדיאטניות שלנו בדקו את בקשתך אך המזון לא התווסף מכיוון שלא ניתן להוסיף מתכון אלא פריט בודד בלבד.",
  recipieNotAllowed: "מתכון",
  missingInformationLong:
    "הדיאטניות שלנו בדקו את בקשתך אך המזון לא התווסף מכיוון שלא העלית מספיק מידע על המוצר. המינימום הנדרש הוא צילום שם המוצר וטבלת הערכים התזונתיים.",
  missingInformation: "חסר מידע",
  treatedAt: "טופל ב",
  foodUnits: "יחידות מזון",
  userDetails: "פרטי משתמש",
  treatedButNoAnswer: "טופל - אך אין תשובה",
  noFoodsHaveBeenTreatedYet: "לא נמצאו מזונות שטופלו",
  noMissingFoodsFoundForTreatment: "לא נמצאו מזונות חסרים לטיפול",
  nutritionalValuesPer100Grams: "ערכים תזונתיים ל-100 גרם",
  gram: "גרם",
  carbohydrates: "פחמימות",
  fats: "שומנים",
  proteins: "חלבונים",
  missingFoodAlreadyExists: "המזון כבר קיים",
  treatedMissingFoods: "מזונות חסרים שטופלו",
  back: "חזרה",
  barcode: "ברקוד",
  today: "היום",
  tomorrow: "מחר",
  inTwoDays: "מחרתיים",
  inThreeDays: "בעוד 3 ימים",
  birthYear: "שנת לידה",
  thanksFillingSurvey: "תודה על מילוי השאלון",
  thanksFillAnotherSurvey:
    "תודה על מילוי השאלון, הנך מועבר למילוי השאלון השני.",
  phoneNotExists: "מס' טלפון אינו קיים",
  birthDate: "תאריך לידה",
  meetingDate: "תאריך שיחה",
  birthDateDay: "יום",
  action: "פעולה",
  birthDateMonth: "חודש",
  birthDateYear: "שנה",
  bloodRelativeQuestion: "האם קרוב/ת משפחה שלך (קרבת דם) משתתף/ת במחקר?",
  bloodTest: "בדיקת דם",
  ehr: "תיק רפואי",
  filesNotBeenSubmitted: "טרם הועלו קבצים.",
  bloodTests: "בדיקות דם",
  sendAppSms: "שלח סמס להורדת האפלקצייה",
  lifeStyleSurvey: "שאלון אורח חיים",
  updatedBloodTests: "בדיקות דם עדכניות",
  bloodTests: "בדיקות דם",
  bloodTestsFilled: " העלאת בדיקות הדם הסתיימה בהצלחה",
  bloodTestsFilled: " העלאת בדיקות הדם הסתיימה בהצלחה",
  otherBloodTests: "על מנת להעלות את בדיקות הדם אנא צור/צרי קשר עם ",
  theTechnicalSupport: "התמיכה טכנית",
  bloodTestsList: "רשימת הבדיקות שאנו מבקשים, ",
  foundHere: "נמצאת כאן",
  bloodTestUploaded: "בדיקות הדם שהועלו:",
  medicalFilesUploaded: {
    bloodTests: "בדיקות הדם שהועלו:",
    ehr: "התיקים הרפואיים שהועלו:",
  },
  initialBloodTestsFileName: "רשימת בדיקות דם.pdf",
  followupVisitBloodTestsFileName: "רשימת בדיקות דם לביקור מעקב.pdf",
  bristolStoolScore: "ציון צואה בריסטול",
  brother: "אח",
  cancel: "ביטול",
  cantLoadMEdications: "שגיאה בטעינת התרופות שלך",
  changeTheAppointmentTime: "לשינוי מועד הפגישה",
  chooseKupa: "בחר קופת חולים",
  clalit: "כללית",
  clalitUploadTextMessage: `יש לבחור הורדת קובץ אקסל (CSV) באתר האינטרנט של הקופה - לקבלת הסבר מפורט יש ללחוץ על סמל קופ"ח כללית.`,
  maccabiBloodTestTextMessage: `יש להוריד את הקובץ מאתר הקופה ולא מהאפליקציה בטלפון הנייד`,
  clickHere: "לחצ/י כאן",
  cm: 'ס"מ',
  codeSentAgain: "שלחנו לך את הקוד שוב ב-SMS",
  command: "פעולה",
  connect: "התחברות",
  contact: "צור קשר",
  dateFormat: "בפורמט: DD/MM/YYYY",
  dateIsNotValid: "התאריך אינו תקין",
  dateOfBloodTest: "תאריך בדיקת דם",
  daughter: "בת",
  day: "יום",
  deleteUserAccount: "מחיקת חשבון",
  deleteUserAccountKeepDate: "האם אתה בטוח שאתה רוצה למחוק את החשבון שלך?",
  deletion: "מחיקה",
  didNotReceiveSms: "לא קיבלת את הקוד?",
  doYouWishToContinue: "האם את/ה רוצה להמשיך?",
  email: "אימייל",
  emailIsNotValid: "כתובת המייל אינה תקינה",
  end: "סיום",
  enterPhoneNumber: "הכנס מספר טלפון",
  enterPhoneNumberOrParticipantId: "הכנס טלפון או מספר משתתף",
  errorFillingReviewInformationMessage:
    "באפשרותך לעבור על המידע שהוזן ולוודא כי לא חלה טעות במילוי המידע.",
  exceptionalBloodPressure: "לחץ דם חריג",
  exceptionalBloodPressureContent: "ערכי לחץ דם הבאים הינם חריגים:",
  father: "אב",
  female: "אשה",
  filesUploaded: "הקבצים הועלו בהצלחה",
  fillBloodTests: "להעלאת בדיקות דם",
  fillEhr: "להעלאת התיק הרפואי",
  fillLaboratory: "לקביעת פגישה",
  fillSurvey: "למילוי השאלון",
  fillSurveyDone: "השאלון מולא במלואו!",
  fillSurveyExplanation: {
    ibs: "תסמונת המעי הרגיז היא אחת הסיבות הנפוצות לביקור אצל רופא המשפחה. אנו נשלב את המידע משאלון זה עם תוצאות בדיקותיך כדי לקבל הבנה עמוקה של גורמי הסיכון לתסמונת. השאלון לוקח כ- 20 דקות.",
    initial:
      "אנא מלא/י שאלון זה, הלוקח כ-30 דקות, ומאפשר לנו הבנה טובה של ההיסטוריה הרפואית שלך, ופיתוח המודל המלא והנכון לפרופיל הרפואי שלך.",
    "initial-pnp":
      "אנא מלא/י שאלון זה, הלוקח כ-30 דקות, ומאפשר לנו הבנה טובה של ההיסטוריה הרפואית שלך, ופיתוח המודל המלא והנכון לפרופיל הרפואי שלך.",
    ukbb: "שאלון כללי זה לוקח כשעה ויאפשר לנו ללמוד על מצבך ולהשוות נתונים בצורה אנונימית למאגרי מידע בינלאומיים. יש להשאיר את הדפדפן פתוח עד לסיום מילוי השאלון.",
    shortUkbb:
      "תודה על השתתפותך בפרויקט חיזוי המחלות. על מנת להשאר מעודכנים על מצבך ולעקוב אחרי שינויים רפואיים שקרו, נודה לך אם תוכל למלא את השאלון המצ״ב (כ 10 דקות).",
  },
  firstName: "שם פרטי",
  pleaseEnterYourPhoneNumber: "אנא הכנס/י את מספר הפלאפון",
  generalError: "שגיאה בלתי צפויה",
  generalLoginText: "אנא מלא/י את מס' הטלפון.",
  generalSignUpCohortText: "אנא מלא/י את הפרטים הבאים.",
  rowsPerPage: "שורות לעמוד",
  group: "קבוצה",
  groupPlaceholder: "בחר קבוצה",
  hasBeenPosted: "הועלתה לאתר ב-",
  height: "גובה",
  help: "עזרה",
  technicalSupport: "תמיכה טכנית",
  here: "כאן",
  home: "בית",
  imStaying: "אני נשאר",
  invalidNumbers: "הכנס מספר",
  invalidNumbersMeasurement: "הכנס מספרים בפורמט הבא LLL/RRR",
  invalidRange: "טווח לא תקין",
  ios: "iOS",
  joiningToTeam: "הצטרפות לצוות המחקר 10k",
  kg: 'ק"ג',
  kitCode: "קוד",
  kupatHolim: "קופת חולים",
  lastName: "שם משפחה",
  leumit: "לאומית",
  login: "כניסה",
  logInToYourAccount: "התחבר/י לחשבונך",
  logout: "יציאה",
  logToYourAccount: "כניסה לחשבונך",
  maccabi: "מכבי",
  male: "גבר",
  medicationName: "שם התרופה",
  medications: "תרופות",
  menu: "תפריט",
  meuhedet: "מאוחדת",
  missingCode: "חסר קוד מזהה",
  missingFirstName: "חסר שם פרטי",
  missingGender: "חסר מגדר",
  missingKupatHolimBloodTests: "בדיקות דם חסרות מקופת החולים",
  missingLastName: "חסר שם משפחה",
  missingList: "רשימת הבדיקות החסרה היא",
  missingParticipantIdOrInvalid: "מספר משתתף חסר או אינו תקין",
  missingVerifyCode: "חסר קוד אימות",
  month: "חודש",
  mother: "אם",
  name: "שם",
  next: "הבא",
  no: "לא",
  noActive: "לא פעיל",
  noData: "אין נתונים",
  noMedicationsFound: "אין תרופות מתאימות",
  noStreet: "ללא רחוב",
  noStreetWithDashed: "-ללא רחוב-",
  notSupportedBrowser:
    "הדפדפן בו אתה משתמש לא נתמך. אנו ממליצים להשתמש בדפדפן ",
  numberParticipantQuestion: "מה מספר המשתתף או מספר הטלפון שלו/שלה?",
  ok: "אישור",
  oldBloodTest: "לא עדכני",
  onTheNecessaryChecklist: "ברשימת הבדיקות הנחוצה",
  participantId: "מספר משתתף",
  participantIdNotFound: "מספר משתתף אינו קיים",
  participantOrPhoneNotExists: "טלפון או מספר משתתף אינו קיים",
  permissions: "הרשאות",
  phone: "טלפון",
  phoneIsNotValid: "מספר הטלפון אינו תקין",
  phoneIdOrEmailAlreadyExists: "טלפון, תעודת זהות או אימייל כבר רשומים במערכת",
  enterBeforeUploadingBloodTests:
    "אנא הזנ/י את הפרטים הבאים לפני העלאת תוצאות:",
  pleaseRemainInProject10K: "אנא השאר בפרוייקט",
  pleaseTypeTheCodeThatSentToYou: "הכנס את הקוד אשר נשלח אליך כעת בהודעת סמס.",
  goBack: "חזור >",
  receiveDataAndSupport: "קבלת נתונים ותמיכה",
  redirectToLogin: "עבור לכניסה",
  relationshipType: "סוג קירבה",
  reports: "דוחות",
  participantNotStartedFirstYear: "המשתתף עדיין לא החל בתהליך השנתי",
  researchTerms: "תנאי המחקר",
  residenceParticipantQuestion:
    "האם מישהו/י החולק עימך מגורים משותפים משתתף/ת במחקר?",
  save: "שמור",
  send2faAgain: "לא קיבלת את הקוד?",
  sendCode: "שלח קוד",
  serverIsDown: "אופס, יש לנו בעיות בשרת. אנא נסה מאוחר יותר.",
  shareSubject: "הצטרפות למחקר ניבוי ומניעת מחלות אישי",
  signup: "הרשמה",
  sister: "אחות",
  to: "ל",
  smartphoneQuestion: {
    female: "אני משתמשת בטלפון חכם.",
    male: "אני משתמש בטלפון חכם.",
  },
  son: "בן",
  afterVisitReport: 'שלח דו"ח אחרי ביקור',
  noMedicalConditions: "אין אבחנות רפואיות",
  noMedications: "אין תרופות",
  startYear: "שנת התחלה",
  startMonth: "חודש התחלה",
  endMonth: "חודש סיום",
  endYear: "שנת סיום",
  medicalCondition: "מצב רפואי",
  uploadMedicalConditions: "העלאת מצבים רפואיים",
  uploadMedicalProcedures: "העלאת הליכים רפואיים",
  uploadHospitalizations: "העלאת אשפוזים",
  stageOne: "שלב ראשון",
  stageThree: "שלב שלישי",
  stageTwo: "שלב שני",
  stayInSignup: "השאר בהרשמה",
  medicalSurvey: "שאלון רפואי",
  survey: "שאלון",
  surveyNotSupported:
    "אנו מתנצלים, אך איננו תומכים במילוי הסקר בדפדפן " +
    "{}" +
    " השתמש ב-" +
    "Chrome" +
    " במקום זאת.",
  testedAt: "נבדק בתאריך",
  doneAt: "בוצע בתאריך",
  receivedAt: "נקלט בתאריך",
  participantUploadedMicrobiome: "המשתתף העלה את הנתונים דרך האפליקציה",
  textButtonDeleteUserAccount: "כן מחק את החשבון שלי וגם את המידע",
  textButtonDeleteUserAccountKeepData: "מחק את החשבון שלי",
  textButtonYesIWantToLogOut: "אני רוצה להתנתק",
  thisPageIsNotAvailable: "לא ניתן להעלות קבצים בטלפון אלא משולחן עבודה בלבד",
  token: "קוד שהתקבל בסמס",
  toMobilePhoneInSms: "ב-SMS לטלפון הנייד",
  didYouOpenTheFilesAfterDownloadingFromClalitsite:
    "האם פתחת את הקבצים לאחר הורדתם מאתר כללית?",
  toSendAgain: "לשליחה נוספת ",
  toWatch: "לצפייה",
  oneTimePassword: "קוד כניסה חד פעמי",
  oneTimePasswordNotValid: "הקוד שגוי",
  unit: "יחידה",
  unregistered: "לא רשום/ה?",
  update: "עדכן",
  updateDetails: "עדכון פרטים",
  upload: "העלה נתונים",
  uploadData: "העלה נתונים",
  userExists: "משתמש קיים",
  username: "שם משתמש",
  userNotExists: "משתמש לא קיים",
  detailsSuccessfullyUpdated: "הפרטים עודכנו בהצלחה",
  value: "ערך",
  verifyCodeMustBe6CharacterLong: "קוד האימות חייב להיות באורך 6 תווים",
  verifyDetails: "אימות פרטים",
  visitingLab: "ביקור במעבדה",
  weight: "משקל",
  other: "אחר",
  year: "שנה",
  yes: "כן",
  mandatory: "מנדטורי",
  cohort: "קבוצת מחקר",
  cohorts: "קבוצות מחקר",
  users: "משתמשים",
  reason: "סיבה",
  approved: "מאושר",
  editingFoods: "עריכת מזונות",
  searchFoodPlaceholder: "חפשי מזונות לעריכה: חלב, ביצים...",
  noFoodsWereFoundForEditing: "לא נמצאו מזונות לעריכה",
  threeMonthsRejection: "דחייה ל-3 חודשים",
  permanentDisqualification: "דחייה לצמיתות",
  medicationUpdatedSuccessfully: "תרופה עודכנה בהצלחה",
  userSuccessfullyAdded: "המשתמש הוסף בהצלחה",
  receiveParticipantId: "קבלת מספר משתתף",
  noReportsAvailable: "אין דוחות זמינים",
  chooseExcludeType: "בחר סוג דחייה",
  emailOrPhone: "טלפון או אימייל",
  getParticipantId: "קבלת מספר משתתף",
  didNotFoundParticipantIdForSearch: "לא נמצא מספר משתתף עבור החיפוש",
  enterEmailOrPhone: "נא להכניס מספר טלפון או אימייל",
  copyToClipboardParticipantId: "לחץ/י על מספר המשתתף להעתקה ללוח",
  participantIdSuccessfullyCopied: "מספר המשתתף הועתק",
  rejectionType: "סוג דחייה",
  unifiedName: "שם מאוחד",
  uploadBloodTests: "העלאת בדיקות",
  uploadedTests: "בדיקות שהועלו",
  missingBloodTests: "בדיקות חסרות",
  uploadedCompleted: "העלאת הבדיקות הסתיימה:",
  allowAppointmentEvenIfTestsNotCompleted:
    "אפשר פגישה גם אם העלאת הבדיקות לא הסתיימה:",
  allowAppointmentSettingInLaboratory: "אפשר קביעת פגישה במעבדה",
  disableAppointmentSettingInLaboratory: "בטל קביעת פגישה במעבדה",
  meetingHasBeenAllowed: "קביעת הפגישה במעבדה אופשרה",
  meetingHasBeenDisabled: "קביעת הפגישה במעבדה בוטלה",
  xFilesFailed: "{} קבצים נכשלו",
  sendCgmReport: 'שלח דו"ח CGM',
  sendDnaReport: 'שלח דו"ח DNA',
  reportHasBeenSent: "הדוח נשלח למייל",
  noMissingBloodTests: "אין בדיקות חסרות",
  testDate: "תאריך בדיקה",
  fileName: "שם קובץ",
  uploadedAt: "הועלה ב-",
  uploadedBy: "הועלה על ידי",
  manuallyUploaded: "הועלה ידנית",
  clalitOpenedFilesMessage:
    "חשוב לא לפתוח את הקבצים לאחר שהורדו מאתר כללית. במידה ופתחת אותם, נא להורידם מחדש ולהעלות בלי לפתוח את הקבצים.",
  reportWasNotSentBecauseThereIsNoData: 'הדו"ח לא נשלח בגלל שאין נתונים',
  continue: "המשך",
  defaultEmailIsTheParticipantEmail:
    "אימייל ברירת המחדל הוא האימייל של המשתתף.",
  enterTheCodeYouReceivedViaSms: "הכנס את הקוד שקיבלת בסמס.",
  tokenNotExists: "קוד אימות אינו קיים",
  pnpParticipant: "משתתף PNP",
  isTreated: "טופל",
  createdAt: "תאריך יצירה",
  markAsTreated: "סמן כטופל",
  missingFoodNotExists: "המזון אינו קיים",
  images: "תמונות",
  factory: "מפעל",
  description: "תאור",
  ingredients: "רכיבי מזון",
  unitName: "שם יחידה",
  foodSuccessfullyCreated: "המזון נוצר בהצלחה",
  foodSuccessfullyUpdated: "המזון עודכן בהצלחה",
  notActive: "לא פעיל",
  unitNotActiveMessage:
    "שימי לב - כאשר נרצה למחוק יחידה לפעמים היחידה תמחק ולפעמים היחידה תסומן עם הכיתוב לא פעיל כאשר היחידה נמצאת בשימוש אצל משתמשים שתיעדו ארוחות.",
  addUnits: "הוספת יחידות",
  teudatZehut: "תעודת זהות",
  teudatZehutIsNotValid: "תעודת הזהות אינה תקינה",
  phoneWillConnectYouToTheSystem: "הטלפון ישמש אותך להתחברות למערכת",
  requestDetails: "פרטי בקשה",
  comment: "הערה",
  createdBy: "נוצר על ידי",
  noMedicalInformationShouldBeIncludedInTheFieldComment:
    "אין לכלול בהערה כל מידע רפואי.",
  informConsent: "הסכמה מדעת",
  breakfast: "ארוחת בוקר",
  lunch: "ארוחת צהריים",
  nightly: "ארוחה לילית",
  dinner: "ארוחת ערב",
  weightInGrams: "משקל (גרם)",
  amount: "כמות",
  startDate: "תאריך התחלה",
  participantDidNotHaveCgmSensorActivated: "למשתתף זה לא הופעל חיישן cgm.",
  calories: "קלוריות",
  totalCaloriesForMeal: "סך הכל קלוריות לארוחה",
  hebrewName: "שם בעברית",
  englishName: "שם באנגלית",
  onlyEnglishLetters: "רק אותיות באנגלית מותרות",
  onlyHebrewLetters: "רק אותיות בעברית מותרות",
  noInternetConnection: "אין חיבור לרשת",
  medicationAddedSuccessfully: "התרופה נוספה בהצלחה",
  typeMedicationToSearch: "הקלד תרופה לחיפוש",
  addNewMedication: "הוסף תרופה חדשה",
  medicationDeletedSuccessfully: "התרופה נמחקה בהצלחה",
  hebrewNameAlreadyExists: "השם בעברית קיים במערכת",
  englishNameAlreadyExists: "השם באנגלית קיים במערכת",
  searchFoods: "חפש מזונות",
  lastReminder: "תזכורת אחרונה",
  id: "מזהה",
  food: "מזון",
  typeFoodToSearch: "הקלד מזון לחיפוש",
  date: "תאריך",
  mealDetails: "פרטי הארוחה",
  getData: "קבל נתונים",
  gym: "כושר",
  wantToComeToLab: "מעוניינ/ת להגיע למעבדה?",
  theLastBloodTestUploadedOn: "בדיקת הדם האחרונה שהועלתה ב-",
  youHaveNoPermission: "אין לך הרשאה מתאימה",
  foods: "מזונות",
  usersBeforeMeetings: "משתתפים שעדיין לא נקבעה להם פגישה",
  usersNotReturnedCgm: "משתתפים שלא החזירו חיישן CGM",
  walking: "הליכה",
  running: "ריצה",
  participantStatusHaveBeenUpdated: "סטטוס המשתתף עודכן בהצלחה",
  notFoundBeforeAppointment: "לא נמצאו משתתפים שהם לפני פגישה.",
  noUsersFound: "לא נמצאו רשומות מתאימות",
  registrationDate: "תאריך הרשמה",
  bicycle: "אופניים",
  snack: "ארוחה קלה",
  yogaAndPilates: "יוגה ופילאטיס",
  sendSleepReport: 'שלח דו"ח שינה',
  support: "תמיכה",
  football: "כדורגל",
  basketball: "כדורסל",
  swimming: "שחייה",
  cgmScannedAt: "התחלת חיישן CGM",
  sleepScannedAt: "התחלת חיישן שינה",
  weightLifting: "הרמת משקולות",
  martialArts: "אומנויות לחימה",
  aerobic: "אירובי",
  minutes: "דקות",
  sleep: "שינה",
  startingTime: "שעת התחלה",
  sleepTime: "שעת שינה",
  wakeTime: "שעת קימה",
  hours: "שעות",
  hour: "שעה",
  onDate: "בתאריך",
  participant: "משתתף",
  participantDidNotRecordMealsSleepAndTraining:
    "המשתתף לא תיעד ארוחות, שינה ואימונים.",
  minimumUploadBloodTestDateFrom2010:
    "תאריך העלאת בדיקת דם מינימלית משנת 2010 ומעלה",
  microbiomeCannotBeProcessed: "לא ניתן לעבד microbiome",
  tubeWasCancelled: ".Microbiome tube can't be received \n\n.The test tube was rejected",
  resetPassword: "איפוס סיסמה",
  passwordWasResetSuccessfuly:
    "המשתמש יוכל לקבוע סיסמה חדשה בכניסה הבאה למערכת.",
  password: "סיסמה קבועה",
  yourPassword: "הסיסמה הקבועה שלך",
  enterPassword: "הכנס סיסמה",
  choosePassword: "בחר סיסמה",
  passwordTooShort: "סיסמה חייבת להיות באורך % תוים או יותר",
  passwordTooEasyToGuess: "בחרת בסיסמה נפוצה ולכן קלה לניחוש. נסו סיסמה אחרת",
  passwordSavedSuccessfuly: "הסיסמה נשמרה בהצלחה",
  passwordPurpose: "הסיסמה תשמש אותך מעתה והלאה בכניסה למערכת",
  passwordHelper: "שכחת סיסמה? פנה למנהל בבקשה לאיפוס סיסמה",
  passwordNotValid: "הסיסמה שגויה",
  bloodTestParsingFailed:
    "פיענוח הקובץ נכשל. נבדוק את הבעיה ונחזור אליך בהקדם. תודה",
  researchStage: "שלב במחקר",
  coordinator: "מתאמת",
  pasteSurveyLinkHere: "הדביקו כאן קישור של השאלון כדי לשמור אותו להמשך",
  invalidSurveyUrl: "הקישור אינו תקין",
  surveyIsSavedButNotFinished: "ניתן לחזור למסך זה ולהמשיך מאותו שלב בשאלון",
  appointmentSetTo: "קבעת תור ל",
  relativeComments: [
    "אם יש מספר קרובי משפחה, אפשר למלא את השאלון מספר פעמים.",
    "עבור קרוב משפחה שגר יחד עם המשתתף, יש למלא בשני ההצדדים.",
  ],
  phoneNumber: "מספר טלפון",
  updateAppointment: "עדכון פגישה",
  userSearchPlaceholder: "חיפוש שם, טלפון או מספר משתתף",
  scheduleCall: "קבע שיחה",
  updateCall: "עדכון שיחה",
  settingVisitFor: "קביעת פגישה עבור",
  settingCallFor: "קביעת שיחה עבור",
  fastingGuidelines: "על הצום להיות בין 0-18 שעות",
  prescreenDisplayTitle: "משתמשים טרם הרשמה",
  status: "סטטוס",
  notValidEmail: "כתובת מייל אינה תקינה",
  notValidPhone: "מספר נייד אינו תקין",
  testParticipants: "Test Participants",
  testersAmount: "Number of testers",
  dateInitialVisit: "Date of 00_00_visit",
  okay: "OK",
  createdSuccessfully: "Created Successfully",
  emailAddress: "Email address",
  medicalDescriptionTitle: {
    ehr: "תיקים רפואיים",
    bloodTests: "בדיקת דם",
  },
  uploadMoreBloodTests: "נודה אם תעלה/י תוצאות בדיקות דם מהשנים האחרונות.",
  medicalFilesInfo1: {
    bloodTests: "בחלק זה, נבקשך להעלות לאתר המחקר קבצי בדיקות דם שביצעת בעבר בקופת החולים שלך. בסרטון ההסבר שבעמוד זה, ניתן לראות כיצד לבצע את העלאת הקובץ. לכל קופת חולים התהליך מעט שונה.",
    ehr: `
    סיכום תיק רפואי זהו מסמך, או קבוצת מסמכים, אשר ניתן להפיק מאתר קופת החולים שלך. המידע כולל את רשימת האבחנות הרפואיות והתרופות כפי שעודכנו במאגרי קופת החולים.
    `
  },
  onlyPdfAllowed: "חשוב: אנא העלו רק מסמכי PDF מקופת החולים, לפי המוסבר בסרטון ההדרכה ולא מידע רפואי ממקורות אחרים.",
  medicalFilesBoxText: {
    bloodTests: "להסבר מפורט כיצד ניתן להעלות את תוצאות בדיקות",
    ehr: "להסבר מפורט כיצד ניתן להעלות את התיקים",
  },
  medicalFilesBoxTextMore: {
    bloodTests: "הדם, נא בחר/י את קופת החולים שלך.",
    ehr: "הרפואיים, נא בחר/י את קופת החולים שלך.",
  },
  uploadMedicalFilesResults: {
    ehr: "העלה/י קבצי תיק רפואי",
    bloodTests: "העלה/י תוצאות בדיקות הדם",
  },
  sendUsMedicalFiles: {
    bloodTests: "לכל שאלה, אנא פנו ",
    ehr: "לכל שאלה, אנא פנו ",
  },
  uploadCanTakTakeTime: "הקובץ עולה, נא המתינו לסיום התהליך",
  goToHmoWebsite: "לאתר הקופה",
  selectedHmo: "את/ה בחרת בקופת החולים HMO.",
  lessUsersCreated: "לא נוצרו כל המשתתפים שביקשת כיוון שכמות המשתתפים הקיימים הינה המקסימאלית, יש למחוק מעט משתמשים.",
  inReview: "בטיפול",
  failed: "נכשל",
  finished: "עלה בהצלחה",
  medicalFileUnderReview: "הקובץ התקבל ועבר לבדיקה",
  medicalFilesSucceed: "הקובץ עלה בהצלחה",
  medicalFilesInReview: "המערכת לא הצליחה לקרוא נתונים מהקובץ באופן אוטומטי והוא עבר לבדיקתנו. נשמח אם תוכל/י לצפות בסרטון שנית ולוודא שפעלת על פי ההנחיות ולהוריד שנית את הקובץ במקרה הצורך.",
  medicalFilesFailed: "המערכת לא הצליחה לקרוא נתונים מהקובץ. נבקשך לצפות בסרטון ההסבר ולהעלות שנית על פי ההנחיות או לפנות לתמיכה",
};

export default texts;
